import { usePurchasePreference } from "../hooks/usePurchasePreference";
import { useEffect, useRef, useState } from "react";
import { useLocale } from "../contexts/LocaleContext";
import { readPreference, savePreference } from "../lib/purchaseGuide";

export function PurchaseGuide({ kind, enabled = true, registrationComplete = false }: { kind: "world" | "cart"; enabled?: boolean; registrationComplete?: boolean }) {
  const { t } = useLocale();
  const key = `${kind}-guide-hidden`;
  const [dismissed, setDismissed] = useState(() => !registrationComplete && readPreference(key));
  const [hide, setHide] = useState(() => readPreference(key));
  const [stay, setStay] = usePurchasePreference("stay-on-map");
  const dialog = useRef<HTMLDialogElement>(null);
  useEffect(() => {
    const el = dialog.current;
    if (enabled && !dismissed && el && !el.open) el.showModal();
    return () => { el?.close(); };
  }, [enabled, dismissed]);
  const close = () => { savePreference(key, hide); setDismissed(true); };
  return <>
    {enabled && dismissed && <button type="button" className="purchase-guide-help" onClick={() => setDismissed(false)}>{t("guide.help")}</button>}
    <dialog ref={dialog} className="purchase-guide" aria-labelledby={`${kind}-guide-title`} onCancel={close}>
    <h2 id={`${kind}-guide-title`}>{t(`guide.${kind}Title`)}</h2>
    {registrationComplete && <p>{t("guide.thankYou")}</p>}
    <p>{t(`guide.${kind}Text`)}</p>
    <label><input type="checkbox" checked={hide} onChange={e => setHide(e.target.checked)} /> {t("guide.hide")}</label>
    {kind === "cart" && <label><input type="checkbox" checked={stay} onChange={e => {
      setStay(e.target.checked);
    }} /> {t("guide.stay")}</label>}
    <button type="button" autoFocus onClick={close}>{t("guide.continue")}</button>
  </dialog></>;
}
